/*
 * LEON 2026-10-11 (Sprint 8) – Titelseiten-Suche im Browser
 * Daten: Section "leon-cover-index" (/?sections=leon-cover-index), 6 Std. im Browser gespeichert.
 * Füllt:
 *   [data-lch-pred]  im Such-Overlay  → Reihe mit Cover-Treffern
 *   [data-lch-page]  auf der Suchseite → Karten mit Warenkorb, Sortierung, Seiten
 *   [data-lsp-q]     Suchfeld der Suchseite → Star-Vorschläge mit Anzahl
 * Ohne JavaScript bleibt die normale Shopify-Suche voll nutzbar.
 */
(function () {
  'use strict';
  if (window.LeonCovers) return;

  var KEY = 'leon-ci-v1';
  var TTL = 6 * 60 * 60 * 1000;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var promise = null;

  function norm(x) {
    return String(x || '').toLowerCase().normalize('NFKD').replace(/[̀-ͯ]/g, '').replace(/ß/g, 'ss').replace(/\s+/g, ' ').trim();
  }
  function esc(x) {
    return String(x == null ? '' : x).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function money(cents) {
    var v = (cents / 100).toFixed(2).replace('.', ',');
    return v + ' €';
  }
  function img(path, w) {
    if (!path) return '';
    return root + 'cdn/shop/' + path + (path.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function prepare(d) {
    var stars = {}, starList = [];
    (d.s || []).forEach(function (s) { if (s) stars[norm(s[0])] = s[1]; });
    var counts = {};
    var items = (d.v || []).map(function (v) {
      var p = d.p[v[0]] || ['', 0];
      var e = v[3] || '';
      var m = /^(\d{1,2})\.(\d{1,2})\.(\d{4})/.exec(e);
      var sort = m ? m[3] + ('0' + m[2]).slice(-2) + ('0' + m[1]).slice(-2) : String(p[1]) + '0000';
      var names = String(v[4]).split(',').map(function (n) { return n.trim(); }).filter(Boolean);
      names.forEach(function (n) {
        var k = norm(n);
        if (!counts[k]) { counts[k] = { name: n, n: 0, img: v[5] }; starList.push(counts[k]); }
        counts[k].n++;
      });
      return { id: v[1], nr: v[2], date: e, cover: v[4], names: names, key: norm(v[4]), img: v[5], price: v[6], avail: v[7] === 1, url: p[0] + '?variant=' + v[1], year: p[1], sort: sort };
    });
    starList.sort(function (a, b) { return b.n - a.n; });
    return { items: items, stars: stars, starList: starList };
  }

  function load() {
    if (promise) return promise;
    promise = new Promise(function (resolve) {
      try {
        var c = JSON.parse(localStorage.getItem(KEY) || 'null');
        if (c && c.t && Date.now() - c.t < TTL && c.d) { resolve(prepare(c.d)); return; }
      } catch (e) {}
      fetch(root + '?sections=leon-cover-index', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var html = j && j['leon-cover-index'] ? j['leon-cover-index'] : '';
          var m = /<script[^>]*data-leon-cover-index[^>]*>([\s\S]*?)<\/script>/.exec(html);
          var d = m ? JSON.parse(m[1]) : { s: [], p: [], v: [] };
          try { localStorage.setItem(KEY, JSON.stringify({ t: Date.now(), d: d })); } catch (e) {}
          resolve(prepare(d));
        })
        .catch(function () { resolve(prepare({ s: [], p: [], v: [] })); });
    });
    return promise;
  }

  /* Suchbegriff → Ausgaben (alle Wörter müssen im Titelseiten-Text vorkommen) */
  function search(db, q) {
    var t = norm(String(q || '').replace(/\*/g, ' ').replace(/bravo/ig, ' ').replace(/,/g, ' '));
    if (t.length < 2 || /^[\d.\-\/ ]+$/.test(t)) return [];
    var words = t.split(' ').filter(function (w) { return w.length > 1; });
    if (!words.length) return [];
    return db.items.filter(function (it) {
      for (var i = 0; i < words.length; i++) if (it.key.indexOf(words[i]) === -1) return false;
      return true;
    }).sort(function (a, b) { return a.sort < b.sort ? -1 : a.sort > b.sort ? 1 : 0; });
  }
  function count(n) { return n === 1 ? '1 Ausgabe' : n + ' Ausgaben'; }
  function searchUrl(q) { return root + 'search?q=' + encodeURIComponent(q); }

  /* ---------- Such-Overlay ---------- */
  function fillPred(el) {
    if (el.getAttribute('data-done')) return;
    el.setAttribute('data-done', '1');
    var q = el.getAttribute('data-q') || '';
    var limit = parseInt(el.getAttribute('data-limit'), 10) || 8;
    load().then(function (db) {
      var hits = search(db, q);
      if (!hits.length) return;
      var h = '<div class="leon-chp__head"><p class="leon-chp__title">Titelseiten mit „' + esc(q) + '“ <span>· ' + count(hits.length) + '</span></p>' +
        '<a class="leon-chp__all" href="' + esc(searchUrl(q)) + '">Alle zeigen ›</a></div><ul class="leon-chp__row">';
      hits.slice(0, limit).forEach(function (it) {
        h += '<li><a class="leon-chp__item" href="' + esc(it.url) + '"><span class="leon-chp__img">' +
          (it.img ? '<img src="' + esc(img(it.img, 200)) + '" alt="BRAVO Nr. ' + esc(it.nr) + ' vom ' + esc(it.date) + ' – Titelseite: ' + esc(it.cover) + '" width="200" height="267" loading="lazy">' : '') +
          '</span><span class="leon-chp__meta">' + it.year + ' · Nr. ' + esc(it.nr) + '</span><span class="leon-chp__price">' + money(it.price) + '</span></a></li>';
      });
      el.innerHTML = h + '</ul>';
      el.setAttribute('data-lch-hit', '');
      el.hidden = false;
    });
  }

  /* ---------- Suchergebnisseite ---------- */
  function fillPage(el) {
    if (el.getAttribute('data-done')) return;
    el.setAttribute('data-done', '1');
    var q = el.getAttribute('data-q') || '';
    var PAGE = parseInt(el.getAttribute('data-page-size'), 10) || 20;
    var section = el.closest('[data-lsp]');
    load().then(function (db) {
      var hits = search(db, q);
      var skel = section && section.querySelector('[data-lch-skeleton]');
      if (skel) skel.remove();
      if (!hits.length) {
        if (section) {
          var empty = section.querySelector('[data-lsp-empty]');
          if (empty && section.getAttribute('data-has-other') !== '1') empty.hidden = false;
          var t = section.querySelector('[data-lsp-title]');
          if (t && section.getAttribute('data-has-other') !== '1') t.textContent = 'Keine Treffer für „' + q + '“';
        }
        return;
      }
      var more = section && section.querySelector('[data-lsp-more]');
      if (more) more.hidden = false;
      var page = 1, dir = 'asc';
      el.innerHTML = '<div class="leon-chs__head"><h2 class="leon-chs__title">Titelseiten mit „' + esc(q) + '“</h2><p class="leon-chs__sub">' + count(hits.length) + ' gefunden</p></div>' +
        (hits.length > 1 ? '<div class="leon-chs__tools"><div class="leon-chs__sort" role="group" aria-label="Sortierung"><button type="button" data-dir="asc" aria-pressed="true">Älteste zuerst</button><button type="button" data-dir="desc" aria-pressed="false">Neueste zuerst</button></div></div>' : '') +
        '<ul class="leon-chs__grid" data-grid></ul><div data-pages></div>';
      el.hidden = false;
      var grid = el.querySelector('[data-grid]'), pages = el.querySelector('[data-pages]');

      function card(it) {
        var names = it.names.map(function (n) {
          var u = db.stars[norm(n)];
          return u ? '<a href="' + esc(u) + '">' + esc(n) + '</a>' : esc(n);
        }).join(', ');
        return '<li><article class="leon-chs__card"><a class="leon-chs__media" href="' + esc(it.url) + '" tabindex="-1" aria-hidden="true">' +
          (it.img ? '<img src="' + esc(img(it.img, 300)) + '" srcset="' + esc(img(it.img, 200)) + ' 200w, ' + esc(img(it.img, 300)) + ' 300w, ' + esc(img(it.img, 400)) + ' 400w" sizes="(min-width: 1000px) 220px, (min-width: 750px) 30vw, 46vw" alt="BRAVO Nr. ' + esc(it.nr) + ' vom ' + esc(it.date) + ' – Titelseite: ' + esc(it.cover) + '" width="400" height="533" loading="lazy">' : '') +
          '</a><div class="leon-chs__body"><p class="leon-chs__meta"><a href="' + esc(it.url) + '">Nr. ' + esc(it.nr) + ' · ' + esc(it.date) + '</a></p>' +
          '<p class="leon-chs__cover">' + names + '</p><p class="leon-chs__price">' + money(it.price) + '</p><div class="leon-chs__actions">' +
          (it.avail ? '<form method="post" action="' + root + 'cart/add" data-lch-form><input type="hidden" name="id" value="' + it.id + '"><button type="submit" class="btn">In den Warenkorb</button></form>' : '<span class="leon-chs__soldout">Derzeit nicht verfügbar</span>') +
          '</div></div></article></li>';
      }
      function pagesHtml(total) {
        var nums = [];
        for (var n = 1; n <= total; n++) {
          if (n === 1 || n === total || Math.abs(n - page) <= 1) nums.push(n);
          else if (nums[nums.length - 1] !== '…') nums.push('…');
        }
        var h = '<nav class="lch-pages" aria-label="Seiten"><button type="button" class="lch-page" data-page="' + (page - 1) + '"' + (page === 1 ? ' disabled' : '') + ' aria-label="Vorherige Seite">‹</button>';
        nums.forEach(function (n) {
          h += n === '…' ? '<span aria-hidden="true">…</span>' : '<button type="button" class="lch-page" data-page="' + n + '"' + (n === page ? ' aria-current="page"' : '') + ' aria-label="Seite ' + n + '">' + n + '</button>';
        });
        return h + '<button type="button" class="lch-page" data-page="' + (page + 1) + '"' + (page === total ? ' disabled' : '') + ' aria-label="Nächste Seite">›</button></nav>';
      }
      function show() {
        var list = dir === 'asc' ? hits : hits.slice().reverse();
        var total = Math.ceil(list.length / PAGE);
        page = Math.min(Math.max(1, page), total || 1);
        var from = (page - 1) * PAGE, to = Math.min(from + PAGE, list.length);
        grid.innerHTML = list.slice(from, to).map(card).join('');
        pages.innerHTML = total > 1 ? pagesHtml(total) + '<p class="lch-count">Ausgaben ' + (from + 1) + '–' + to + ' von ' + list.length + '</p>' : '';
      }
      pages.addEventListener('click', function (e) {
        var b = e.target.closest('[data-page]');
        if (!b || b.disabled) return;
        page = parseInt(b.getAttribute('data-page'), 10);
        show();
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      el.addEventListener('click', function (e) {
        var b = e.target.closest('[data-dir]');
        if (!b) return;
        dir = b.getAttribute('data-dir');
        el.querySelectorAll('[data-dir]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        page = 1; show();
      });
      grid.addEventListener('submit', addToCart);
      show();
    });
  }

  function addToCart(e) {
    var form = e.target.closest('[data-lch-form]');
    if (!form || !window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('button');
    if (btn.disabled) return;
    var label = btn.innerHTML;
    btn.disabled = true;
    var fd = new FormData(form);
    fd.append('quantity', '1');
    fd.append('sections', 'cart-drawer');
    fetch((window.routes && window.routes.cart_add_url) || form.getAttribute('action'), { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        if (json && json.status && json.status >= 400) throw new Error('cart');
        var bus = window.eventBus;
        if (!bus || !bus.emit) { window.location.href = root + 'cart'; return; }
        bus.emit('update:cart:drawer', json);
        bus.emit('open:cart:drawer', { scrollToTop: true });
        fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          if (window.wetheme && typeof window.wetheme.updateCartCount === 'function') window.wetheme.updateCartCount(cart);
        }).catch(function () {});
        btn.textContent = 'Hinzugefügt';
        setTimeout(function () { btn.innerHTML = label; btn.disabled = false; }, 1800);
      })
      .catch(function () { btn.disabled = false; form.submit(); });
  }

  /* ---------- Suchfeld der Suchseite: Star-Vorschläge ---------- */
  function initField(input) {
    if (input.getAttribute('data-done')) return;
    input.setAttribute('data-done', '1');
    var list = document.getElementById(input.getAttribute('aria-controls'));
    var form = input.closest('form');
    var clear = form && form.querySelector('[data-lsp-clear]');
    var items = [], active = -1;
    function close() { if (!list) return; list.hidden = true; list.innerHTML = ''; items = []; active = -1; input.setAttribute('aria-expanded', 'false'); }
    function open() {
      if (clear) clear.hidden = !input.value;
      var q = norm(input.value);
      if (q.length < 2 || !list) { close(); return; }
      load().then(function (db) {
        if (norm(input.value) !== q) return;
        var a = [], b = [];
        db.starList.forEach(function (s) {
          var k = norm(s.name), i = k.indexOf(q);
          if (i === 0 || k.indexOf(' ' + q) > -1) a.push(s); else if (i > 0) b.push(s);
        });
        items = a.concat(b).slice(0, 7);
        active = -1;
        if (!items.length) { close(); return; }
        list.innerHTML = items.map(function (s) {
          var k = norm(s.name), i = k.indexOf(q), n = s.name;
          var label = i < 0 ? esc(n) : esc(n.slice(0, i)) + '<mark>' + esc(n.slice(i, i + q.length)) + '</mark>' + esc(n.slice(i + q.length));
          var url = db.stars[k] || searchUrl(n);
          return '<li role="option" aria-selected="false"><a href="' + esc(url) + '" tabindex="-1">' +
            (s.img ? '<img src="' + esc(img(s.img, 100)) + '" alt="" width="30" height="40" loading="lazy">' : '<span class="lsp-noimg"></span>') +
            '<span>' + label + '</span><small>' + count(s.n) + '</small></a></li>';
        }).join('');
        list.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      });
    }
    input.addEventListener('input', open);
    input.addEventListener('focus', function () { load(); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        if (!items.length) return;
        e.preventDefault();
        active = (active + (e.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length;
        list.querySelectorAll('li').forEach(function (li, k) { li.setAttribute('aria-selected', k === active ? 'true' : 'false'); });
      } else if (e.key === 'Escape') { close(); }
      else if (e.key === 'Enter' && active > -1) {
        e.preventDefault();
        var a = list.querySelectorAll('a')[active];
        if (a) window.location.href = a.getAttribute('href');
      }
    });
    input.addEventListener('blur', function () { setTimeout(close, 150); });
    if (clear) {
      clear.hidden = !input.value;
      clear.addEventListener('click', function () { input.value = ''; clear.hidden = true; close(); input.focus(); });
    }
  }

  function scan(node) {
    var r = node && node.querySelectorAll ? node : document;
    r.querySelectorAll('[data-lch-pred]:not([data-done])').forEach(fillPred);
    r.querySelectorAll('[data-lch-page]:not([data-done])').forEach(fillPage);
    r.querySelectorAll('[data-lsp-q]:not([data-done])').forEach(initField);
  }

  window.LeonCovers = { load: load, search: search, scan: scan };

  function start() {
    scan(document);
    /* Such-Overlay wird vom Theme nachgeladen → neue Platzhalter automatisch füllen */
    var target = document.querySelector('[data-predictive-search-results]');
    if (target && window.MutationObserver) {
      new MutationObserver(function () { scan(target); }).observe(target, { childList: true, subtree: true });
    }
    /* Daten schon beim Antippen des Suchfelds vorladen */
    document.addEventListener('focusin', function (e) {
      if (e.target && e.target.matches && e.target.matches('[data-predictive-search-input]')) load();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
